import { Box, Code, Link } from '@radix-ui/themes';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { UsersContext } from 'contexts/admin/users.context';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IUser } from 'lib_ts/interfaces/i-user';
import { FC, useContext } from 'react';

interface IProps {
  users: IUser[];
}

export const DeleteUsersDialog: FC<IProps> = (props) => {
  const { deleteUsers } = useContext(UsersContext);

  return (
    <CommonConfirmationDialog
      identifier="DeleteUsersDialog"
      title="common.delete"
      content={
        <Box>
          <p>Are you sure you want to delete the following user(s)?</p>
          <ul>
            {props.users
              .sort((a, b) => StringHelper.safeSort(a.email, b.email))
              .map((u, i) => (
                <li key={i}>
                  <Link href={`mailto:${u.email}`}>
                    <Code>{u.email}</Code>
                  </Link>
                </li>
              ))}
          </ul>
        </Box>
      }
      action={{
        label: 'common.delete',
        color: RADIX.COLOR.DANGER,
        onClick: () => deleteUsers(props.users.map((u) => u._id)),
      }}
    />
  );
};
